import { AxiosInstance } from 'axios';
import { AuthRepository } from '@/model/repository/manager/auth/AuthRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): AuthRepository => ({
    login(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
    check(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
